import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "wouter";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie, X } from "lucide-react";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  function accept() {
    localStorage.setItem("cookie_consent", "accepted");
    setVisible(false);
  }

  function reject() {
    localStorage.setItem("cookie_consent", "rejected");
    setVisible(false);
  }

  return (
    <AnimatePresence>
      {visible && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[60] bg-black/40 backdrop-blur-sm"
            onClick={reject}
          />
          <motion.div
            initial={{ scale: 0.9, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.9, opacity: 0, y: 20 }}
            transition={{ type: "spring", damping: 25, stiffness: 300 }}
            className="fixed z-[61] inset-0 flex items-center justify-center p-4 pointer-events-none"
            data-testid="cookie-banner"
          >
            <div className="bg-card rounded-2xl shadow-2xl border overflow-hidden max-w-md w-full pointer-events-auto">
              <div className="relative px-6 pt-6 pb-4">
                <button
                  onClick={reject}
                  className="absolute top-4 right-4 p-1 rounded-full hover:bg-muted transition-colors"
                  data-testid="button-cookie-close"
                  aria-label="Cerrar"
                >
                  <X className="w-4 h-4 text-muted-foreground" />
                </button>

                <div className="flex items-center gap-3 mb-4">
                  <motion.div
                    animate={{ rotate: [0, -10, 10, -5, 0] }}
                    transition={{ duration: 0.6, delay: 0.3 }}
                  >
                    <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center">
                      <Cookie className="w-5 h-5 text-primary" />
                    </div>
                  </motion.div>
                  <h3 className="font-display font-bold text-base">¡Usamos cookies!</h3>
                </div>

                <p className="text-sm text-muted-foreground leading-relaxed">
                  Para mejorar tu experiencia y analizar el tráfico.{" "}
                  <Link href="/politica-cookies">
                    <span className="underline cursor-pointer text-primary hover:text-primary/80 transition-colors">
                      Más info
                    </span>
                  </Link>
                </p>
              </div>

              <div className="px-6 pb-5 flex gap-2">
                <Button
                  variant="outline"
                  size="sm"
                  onClick={reject}
                  className="flex-1 rounded-xl"
                  data-testid="button-cookie-reject"
                >
                  Solo esenciales
                </Button>
                <Button
                  size="sm"
                  onClick={accept}
                  className="flex-1 rounded-xl"
                  data-testid="button-cookie-accept"
                >
                  Aceptar todas
                </Button>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
